<rid-mechanic-background />

<rid-mechanic-wrapper
  [class]="{
    'cursor-grabbing': isDragging(),
  }"
>
  <rid-top-bar class="block w-full" [name]="name()" [steps]="questions().length" [progress]="progress()" />

  <rid-mechanic-content>
    <!-- title -->
    @for (input of [question().assignment]; track input) {
      <rid-mechanic-title [title]="input" [animate.enter]="index() > 0 ? 'wait-500' : undefined" />
    }

    <!-- options -->
    @for (input of [question()]; track input.id) {
      <div class="absolute flex flex-col place-items-center gap-8 pt-8" animate.leave="anim-fade-out">
        <div
          #draggable="cdkDrag"
          cdkDrag
          class="group z-10"
          [class]="{
            'pointer-events-none': isDragging() || isEvaluating(),
            'pointer-events-auto': !isDragging() && !isEvaluating(),
            'cursor-grab': !isDragging() && !isEvaluating(),
          }"
          (cdkDragStarted)="onDragStarted()"
          (cdkDragMoved)="onDragMoved($event)"
          (cdkDragReleased)="onDragReleased()"
        >
          <div
            class="ease-in-back transition-transform"
            [class]="{
              'scale-0': isCorrect(),
            }"
          >
            <rid-option
              #item
              [option]="input.item"
              class="block transition-transform"
              [class]="{
                'group-hover:shadow-md': !isDragging(),
                'shadow-lg': isDragging(),
                'group-hover:scale-105': !isDragging(),
                'scale-115': isDragging(),
                'group-hover:-rotate-1': !isDragging(),
                '-rotate-5': isDragging(),
              }"
              animate.enter="wait-250 anim-pop-in"
              ridSfx="BUBBLE_POP"
              (animationend)="$event.animationName === 'pop-in' ? onItemPoppedIn() : undefined"
            />
          </div>
        </div>

        <div class="grow"></div>

        <div
          class="flex"
          [class.pointer-events-none]="!areOptionsVisible()"
          [class.invisible]="!areOptionsVisible()"
          [attr.aria-hidden]="!areOptionsVisible()"
        >
          @for (option of question().options; track $index) {
            <div
              class="p-4 transition-all"
              [attr.data-option-index]="$index"
              [class]="{
                'scale-110': target() === $index,
                'scale-95': (isDragging() || isEvaluating()) && target() !== undefined,
                'scale-115': isEvaluating() && target() === $index,
                'grayscale-100': (isDragging() || isEvaluating()) && target() !== undefined && target() !== $index,
              }"
            >
              <rid-option
                #options
                class="block"
                [class]="{
                  'pointer-events-none': !areOptionsVisible() || isDragging() || isEvaluating(),
                  'anim-pop-in': areOptionsVisible(),
                }"
                [option]="option"
                [appearance]="isEvaluating() && target() === $index ? (isCorrect() ? 'CORRECT' : 'INCORRECT') : 'DEFAULT'"
                [style.animation-delay.ms]="areOptionsVisible() ? $index * 100 : null"
                ridSfx="BUBBLE_POP"
              />
            </div>
          }
        </div>
      </div>
    }

    <!-- feedback overlay -->
    <rid-overlay-feedback #overlayFeedback />
  </rid-mechanic-content>
</rid-mechanic-wrapper>
